<template>
  <v-select
    :value="value"
    :items="items"
    item-text="text"
    item-value="id"
    outlined
    dense
    hide-details
    :disabled="disabled"
    :loading="loading"
    @change="handleChange"
  >
    <template v-slot:selection="{ item }">
      <span class="stato-mercato-label" :style="statoMercatoStyle(item)">
        <span class="stato-mercato-dot" />
        <span>{{ item.text }}</span>
      </span>
    </template>
    <template v-slot:item="{ item }">
      <v-list-item-content class="py-1">
        <v-list-item-title
          class="stato-mercato-label"
          :style="statoMercatoStyle(item)"
        >
          <span class="stato-mercato-dot" />
          <span>{{ item.text }}</span>
        </v-list-item-title>
        <v-list-item-subtitle
          v-if="item.description"
          class="stato-mercato-option-description"
          v-html="item.description"
        />
      </v-list-item-content>
    </template>
  </v-select>
</template>

<script>
import * as Helpers from "../../js/helpers";

export default {
  name: "stato-mercato-select",
  props: {
    value: {},
    tipoMercato: {
      type: Object,
      default: () => ({}),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    items() {
      return Helpers.statiMercatiOptions(this.tipoMercato);
    },
  },
  methods: {
    handleChange(value) {
      this.$emit("change", value);
    },
    statoMercatoStyle(item) {
      return {
        ...(item && item.color ? { color: item.color } : {}),
        fontWeight: 700,
      };
    },
  },
};
</script>

<style scoped>
.stato-mercato-option-description {
  color: var(--v-text-base) !important;
  font-size: 12px;
  line-height: 1.25;
  white-space: normal;
}

.stato-mercato-label {
  align-items: center;
  display: inline-flex;
  gap: 6px;
  min-width: 0;
}

.stato-mercato-dot {
  background: currentColor;
  border-radius: 50%;
  display: inline-block;
  flex: 0 0 auto;
  height: 7px;
  width: 7px;
}
</style>
